import { render, staticRenderFns } from "./AlertListWidget.vue?vue&type=template&id=21572056&"
import script from "./AlertListWidget.vue?vue&type=script&lang=js&"
export * from "./AlertListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports